import { Text } from "components/text";
import React from "react";

export const NoTakeawayOrderListItem = () => (
    <Text preset="g-16" className="takeaway-order__list-item takeaway-order__list-item--empty">
        No takeaway orders at this time.
    </Text>
);
